import { Button } from '@localagent/ui/components/button';

export function BackButton({ label, onClick, testId }: { label: string; onClick: () => void; testId?: string }) {
  return (
    <Button variant="ghost" size="sm" className="h-8 w-8 shrink-0 p-0" aria-label={label} data-testid={testId} onClick={onClick}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M19 12H5" />
        <path d="m12 19-7-7 7-7" />
      </svg>
    </Button>
  );
}
